import axios from 'axios';
import { getToken, updateAccessToken } from "../util/keycloak";
import history from 'history/browser';
import { API } from '../env';

const DEFAULT_AXIOS_TIMEOUT = 3000000; //5 minutos
class Api {

  fetch (url, method, body, headers, responseType) {

    axios.interceptors.request.use(async function (config) {
      config.timeout = DEFAULT_AXIOS_TIMEOUT;
      return config;
    });

    axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response.status === 401 || error.response.status === 403) {
          history.push('/unauthorized');
        }
        return Promise.reject(error);
      }
    );

    return axios(this.getRequisicao(url, method, body, headers, responseType));
  }

  getRequisicao (url, method, body, headers, responseType) {
    const TSTSAUDE_API = API;

    let requisicao = {
      url: `${TSTSAUDE_API}${url}`,
      headers: {...headers, ...this.getAuthorizationHeader()},
      withCredentials: true,
    };

    if (responseType) {
      requisicao['responseType'] = responseType;
    }
    if (method) {
      requisicao['method'] = method;
    }
    if (body) {
      requisicao['data'] = body;
    }

    return requisicao;
  }




  getAuthorizationHeader () {
    if (getToken() != null) {
      return {
        'Authorization': `Bearer ${getToken()}`
      };
    }
  }
}

export default Api;
